module.exports = __webpack_public_path__ + "media/images/icon__settings-594f8e3b3f256042b89bc7bf4228d37c.png";